import { Link, useParams } from "react-router-dom";
import MainFooter from "../../module/footer/main_footer";
import SubNavBar from "../../module/nav_bar/sub_nav_bar";
import "./community_page.css";
import NoticePage from "./notice_page";
import InfoPage from "./info_page";
import QnaPage from "./qna_page";
import WritePage from "./write_page";
import PostDetailPage from "./post_detail_page";
import FixedBtn from "../../module/fixed_btn/fixed_btn";

function CommunityPage() {
  const { contents, actions, postId } = useParams() as {
    contents: string;
    actions: string;
    postId: string;
  };

  let content, title;

  //console.log("test: ", contents, actions, postId);

  if (actions === "write") {
    content = <WritePage postType={contents} />;
    title = "게시글 작성";
  } else if (contents === "notice") {
    content =
      actions === "detail" ? (
        <PostDetailPage postType={contents} postId={postId} />
      ) : (
        <NoticePage />
      );
    title = "공지사항";
  } else if (contents === "info") {
    content =
      actions === "detail" ? (
        <PostDetailPage postType={contents} postId={postId} />
      ) : (
        <InfoPage />
      );
    title = "정보마당";
  } else if (contents === "qna") {
    content =
      actions === "detail" ? (
        <PostDetailPage postType={contents} postId={postId} />
      ) : (
        <QnaPage />
      );
    title = "자주 묻는 질문";
  }

  return (
    <div className="community_page">
      <nav>
        <SubNavBar />
      </nav>
      <div className="page_header">
        <div className="page_title">{title}</div>
        <ul className="sub_nav" id="community">
          <Link
            to="/community/notice"
            className="link_btn"
            id={contents === "notice" ? "active" : ""}
          >
            <li>공지사항</li>
          </Link>
          <Link
            to="/community/info"
            className="link_btn"
            id={contents === "info" ? "active" : ""}
          >
            <li>정보마당</li>
          </Link>
          <Link
            to="/community/qna"
            className="link_btn"
            id={contents === "qna" ? "active" : ""}
          >
            <li>자주 묻는 질문</li>
          </Link>
        </ul>
      </div>
      <main className="community_main">{content}</main>
      <FixedBtn />
      <footer>
        <MainFooter />
      </footer>
    </div>
  );
}

export default CommunityPage;
